/* ============
 * Education Modal Component
 * ============
 */
import mixin from "../../mixins/mixin";

export default {
  data() {
    return {

    };
  },
  props: {},
  mixins:[mixin],
  async mounted() {

  },
  methods: {
    open_help () {
      this.openModal('#autoaction-help-modal');
    }
  },
  computed: {

  },
};



// WEBPACK FOOTER //
// ./src/app/components/autoaction-help-modal/autoaction-help-modal.js